import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { applyHandoffFromHash } from "@itaas/core/modules/handoff";
import { getPort } from "@itaas/ports";
import { ensureEstablishmentProfileFromSession } from "@/core/admin/establishment-store";
import { getSuiteLoginUrl } from "@/core/config";
import { routes } from "@/router/all_routes";

export function AuthHandoffPage() {
  const navigate = useNavigate();
  const { verifySession } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const targetFromHash = applyHandoffFromHash(window.location.hash);
    const target = targetFromHash ?? (loadStoredSession() ? routes.tenantDashboard : null);

    if (target) {
      window.history.replaceState(null, "", window.location.pathname);
      void verifySession().then(() => {
        ensureEstablishmentProfileFromSession(loadStoredSession());
        navigate(target, { replace: true });
      });
      return;
    }

    setError(
      `Lien de session invalide ou expiré. Connectez-vous via ITaaS Suite (port ${getPort("suite", "web")}).`,
    );
  }, [navigate, verifySession]);

  if (error) {
    return (
      <div className="ph-login-page">
        <div className="ph-login-card">
          <p className="text-danger mb-3">{error}</p>
          <a href={getSuiteLoginUrl()} className="btn btn-primary">
            Ouvrir ITaaS Suite
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="ph-login-page">
      <div className="ph-login-card">
        <p className="text-muted mb-0">Connexion à ITaaS Hospitol…</p>
      </div>
    </div>
  );
}
